import Input from "../../../../components/input";
import { ValidationPatterns, ValidationMessages } from "../../../../utils/validation";

const RegisterFormContent = ({
  formData,
  handleChange,
  handleUserTypeChange,
  isUserTypeLocked,
  handleValidationChange,
  t,
  showKvkkError,
  onKvkkLinkClick,
}) => (
  <>
    {!isUserTypeLocked && (
      <div className="user-type-selector">
        <label className="user-type-label">
          <i className="zmdi zmdi-account-circle"></i>
          {t("AUTH_FORM_USER_TYPE")}
        </label>
        <div className="user-type-buttons">
          <button
            type="button"
            className={`user-type-btn ${formData.userType === "student" ? "active" : ""}`}
            onClick={() => handleUserTypeChange("student")}
          >
            <i className="zmdi zmdi-graduation-cap"></i>
            <span>{t("AUTH_FORM_USER_TYPE_STUDENT")}</span>
          </button>
          <button
            type="button"
            className={`user-type-btn ${formData.userType === "agent" ? "active" : ""}`}
            onClick={() => handleUserTypeChange("agent")}
          >
            <i className="zmdi zmdi-accounts"></i>
            <span>{t("AUTH_FORM_USER_TYPE_AGENT")}</span>
          </button>
        </div>
      </div>
    )}

    <Input
      type="text"
      name="firstName"
      value={formData.firstName}
      onChange={handleChange}
      placeholder={t("AUTH_FORM_FIRST_NAME")}
      icon="zmdi zmdi-account"
      required
      validationRegex={ValidationPatterns.NAME}
      errorMessage={ValidationMessages.NAME}
      onValidationChange={handleValidationChange}
    />

    <Input
      type="text"
      name="lastName"
      value={formData.lastName}
      onChange={handleChange}
      placeholder={t("AUTH_FORM_LAST_NAME")}
      icon="zmdi zmdi-account"
      required
      validationRegex={ValidationPatterns.NAME}
      errorMessage={ValidationMessages.NAME}
      onValidationChange={handleValidationChange}
    />

    <Input
      type="email"
      name="email"
      value={formData.email}
      onChange={handleChange}
      placeholder={t("AUTH_FORM_EMAIL")}
      icon="zmdi zmdi-email"
      required
      validationRegex={ValidationPatterns.EMAIL}
      errorMessage={ValidationMessages.EMAIL}
      onValidationChange={handleValidationChange}
    />

    <Input
      type="tel"
      name="phone"
      value={formData.phone}
      onChange={handleChange}
      placeholder={t("AUTH_FORM_PHONE")}
      icon="zmdi zmdi-phone"
      required
      validationRegex={ValidationPatterns.PHONE_TR}
      errorMessage={ValidationMessages.PHONE_TR}
      onValidationChange={handleValidationChange}
    />

    <Input
      type="password"
      name="password"
      value={formData.password}
      onChange={handleChange}
      placeholder={t("AUTH_FORM_PASSWORD")}
      showPasswordToggle
      icon="zmdi zmdi-lock"
      required
      validationRegex={ValidationPatterns.PASSWORD_STRONG}
      errorMessage={ValidationMessages.PASSWORD_STRONG}
      onValidationChange={handleValidationChange}
    />

    <div className="form-check text-left register-kvkk-check">
      <label className="form-check-label d-flex align-items-center">
        <input
          type="checkbox"
          name="kvkkAccepted"
          className="form-check-input"
          checked={formData.kvkkAccepted}
          onChange={handleChange}
        />
        <span className="kvkk-text" >
          {t("AUTH_FORM_KVKK_TEXT")}{" "}
          <a
            href="#" style={{ color: '#FFB236' }}
            onClick={(e) => {
              e.preventDefault();
              onKvkkLinkClick();
            }}
          >
            {t("AUTH_FORM_KVKK_LINK")}
          </a>
        </span>
      </label>
      {showKvkkError && !formData.kvkkAccepted && (
        <div className="invalid-feedback kvkk-error">
          {t("AUTH_FORM_KVKK_REQUIRED")}
        </div>
      )}
    </div>
  </>
);

export default RegisterFormContent;

